module.exports = __webpack_public_path__ + "static/media/closing-date.56bdd390.svg";